import { Stack, type StackProps } from '@chakra-ui/react';

export function DisclaimerBox(props: StackProps) {
  return (
    <Stack
      px="3xs"
      py="4xs"
      borderRadius="base"
      borderColor="blackAlpha.250"
      borderWidth="1px"
      {...props}
    />
  );
}
